/* eslint-disable import/prefer-default-export */

import {
  sendInviteRequest,
  sendInviteSuccess,
  sendInviteFailure,
  getDataForInviteFormRequest,
  getDataForInviteFormSuccess,
  getDataForInviteFormFailure,
} from './actionCreators';

import { sendEmailInvite, inviteAssignee } from './api.service';
import { getOrganizations, getRegistrationForms } from '../api.service';

export const inviteUserByEmail = (form) => async (dispatch) => {
  try {
    dispatch(sendInviteRequest());
    let data;
    if (form.isAssignee) {
      const response = await inviteAssignee(form);
      data = response.data;
    } else {
      const response = await sendEmailInvite(form);
      data = response.data;
    }
    dispatch(sendInviteSuccess(data.data));
    return data.data;
  } catch ({ message }) {
    dispatch(sendInviteFailure('Invite failed'));
    return null;
  }
};

/**
 * @param {Object} params
 * @returns {Function}
 */
export const getDataForInviteForm = (params) => async (dispatch) => {
  try {
    dispatch(getDataForInviteFormRequest());
    const { initiative_id: initiativeId, ...rest } = params;
    const { data } = await getOrganizations();
    const formsResponse = await getRegistrationForms(initiativeId, rest);
    dispatch(getDataForInviteFormSuccess(data.data, formsResponse.data.data));
  } catch ({ message }) {
    dispatch(getDataForInviteFormFailure(message));
  }
};
